import apiClient from 'helpers/api-client'
import { StateCreator } from 'zustand'
import {
  IPayloadWithdrawHistory,
  IWithdrawHistory,
} from './interface'

export const createWithdrawHistorySlice: StateCreator<
  IWithdrawHistory
> = (set) => ({
  // state
  isLoadingHistory: false,
  IsHistorySuccess: false,
  withdrawHistory: [],
  withdrawListMetadata: {
    limit: 10,
    load_more: false,
    page: 1,
    total: 0,
  },
  // actions
  getWithdrawHistory: async (payload: IPayloadWithdrawHistory) => {
    try {
      set({
        isLoadingHistory: true,
      })
      const res = await apiClient.get(
        '/wallet/hub/v1/income/withdraw/list',
        {
          params: payload,
        },
      )
      if (res?.data?.code === 'SUCCESS') {
        set({
          withdrawHistory: res?.data?.data,
          withdrawListMetadata: res.data._metadata,
          IsHistorySuccess: true,
        })
      }
      set({
        isLoadingHistory: false,
      })
    } catch (error) {
      set({
        IsHistorySuccess: false,
        isLoadingHistory: false,
      }),
        console.error(error)
    }
  },
})
